import { render, staticRenderFns } from "./TextModePage.vue?vue&type=template&id=aa951db8"
import script from "./TextModePage.vue?vue&type=script&lang=ts"
export * from "./TextModePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports